import { render, staticRenderFns } from "./ComplaintSimpleInfo.vue?vue&type=template&id=6658c3e8&"
import script from "./ComplaintSimpleInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintSimpleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports